import React, { useState, useEffect } from 'react';

export const toast = {
    success: (msg) => {
        window.dispatchEvent(new CustomEvent('bus_toast', { detail: { msg, type: 'success' }}));
    },
    error: (msg) => {
        window.dispatchEvent(new CustomEvent('bus_toast', { detail: { msg, type: 'error' }}));
    }
};

export const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        const handleToast = (e) => {
            const id = Date.now();
            setToasts(t => [...t, { id, ...e.detail }]);
            setTimeout(() => {
                setToasts(t => t.filter(x => x.id !== id));
            }, 3000);
        };
        window.addEventListener('bus_toast', handleToast);
        return () => window.removeEventListener('bus_toast', handleToast);
    }, []);

    return (
        <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8 }}>
            {toasts.map(t => (
                <div key={t.id} style={{ 
                    background: t.type === 'error' ? 'var(--danger)' : 'var(--success)', 
                    color: '#fff', 
                    padding: '12px 24px', 
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                    animation: 'fadeIn 0.3s',
                    minWidth: '250px'
                }}>
                    <strong>{t.type === 'error' ? 'Error' : 'Success'}</strong><br/>
                    <span style={{ fontSize: '0.9rem' }}>{t.msg}</span>
                </div>
            ))}
        </div>
    );
};
